import { dataUploadDesktop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUploadDesktop = /*#__PURE__*/createIcon(dataUploadDesktop)
export default IconUploadDesktop
